import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "ab-query-list-route",
  templateUrl: "./query-list-route.component.html",
})
export class QueryListRouteComponent implements OnInit {
  @Input() public query: any;
  @Input() public lastN: number;
  @Input() public dur: string;

  public showRoutes: boolean;

  public ngOnInit() {
    this.showRoutes = false;
  }

  public trackById(_index: number, item: any) {
    return item.id;
  }

  public toggleShowRoutes() {
    this.showRoutes = !this.showRoutes;
  }

  public sortRoutesByName(routes: any[]): any[] {
    return routes.sort((a: any, b: any) => {
      if (a.route < b.route) {
        return -1;
      }
      if (a.route > b.route) {
        return 1;
      }
      return 0;
    });
  }
}
